import { SUBSCRIPTION_STATUS } from "@/libraries/constant";
import { memberProfileQueryOptions } from "@/queries";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

interface UseProfileProps {
	disableCheckExpired?: boolean;
}

function useProfile(_props: UseProfileProps = {}) {
	const { data: resProfile, ...restProfileQuery } = useQuery(
		memberProfileQueryOptions(),
	);
	const profile = useMemo(() => resProfile?.user, [resProfile]);

	const isFreeTrial = useMemo(
		() =>
			(!profile?.subscription_status ||
				(profile?.subscription_status?.includes("free") &&
					profile?.subscription_plan?.status === "active")) ??
			false,
		[profile],
	);

	const isProPlan = useMemo(
		() =>
			(profile?.subscription_status &&
				[SUBSCRIPTION_STATUS.PRO, SUBSCRIPTION_STATUS.PREMIUM].includes(
					profile?.subscription_status.toLowerCase() as any,
				) &&
				profile?.subscription_plan?.status === "active") ??
			false,
		[profile],
	);

	const isPlusPlan = useMemo(
		() =>
			(profile?.subscription_status &&
				[SUBSCRIPTION_STATUS.PLUS].includes(
					profile?.subscription_status.toLowerCase() as any,
				) &&
				profile?.subscription_plan?.status === "active") ??
			false,
		[profile],
	);

	return {
		profile,
		isFreeTrial,
		isFreePlan: isFreeTrial,
		isProPlan,
		isPlusPlan,
		...restProfileQuery,
	};
}

export default useProfile;
